<script>
    import { createEventDispatcher } from "svelte";
    import Card from "./Card.svelte";
    import { user, business } from "../../firebase/auth";
    import AddCard from "./AddCard.svelte";
    import { Timestamp } from "firebase/firestore";

    const dispatch = createEventDispatcher();
    const now = Timestamp.now();

    export let cards;
    export let blocked;

    function addCard(e) {
        dispatch("add", e.detail);
    }

    function setAutoRenewal(e) {
        dispatch("setAutoRenewal", e.detail);
    }

    function archiveCard(e) {
        dispatch("archive", e.detail);
    }
    
    function removeCard(e) {
        dispatch("remove", e.detail);
    }

    function publishCard(e) {
        dispatch("publish", e.detail);
    }
</script>

<h1>Stempelkarten</h1>

<div class="cards">
    {#if cards && cards.length > 0}
        {#each cards as card (card.id)}
            <Card bind:card on:remove={removeCard} on:setAutoRenewal={setAutoRenewal} on:publish={publishCard} on:archive={archiveCard} now={now}/>
        {/each}
    {:else}
        <div class="tip">
            <span>keine Stempelkarten vorhanden</span>
        </div>
    {/if}
    <AddCard on:addCard={addCard} bind:blocked></AddCard>
</div>


<style>
    .cards {
        display: grid;
        gap: 1rem;
    }

    .tip {
        text-align: center;
        padding-top: 1rem;
        padding-bottom: 1rem;
        font-style: italic;
    }

</style>